// PaidInteractionPanel.js
'use strict';
import { connect } from 'react-redux';

import PaidInteractionPanel from '../component/PaidInteractionPanel.jsx';

import fetchLivestreamTopGifts from '../action/fetchLivestreamTopGifts.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';

import { LIVESTREAM_TOP_GIFTS_POLLING_SECONDS } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId }) => {
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');

  return {
    sessionId,
    privateShowStatus: getPrivateShowStatus(state, streamId),
    pollingSeconds: getRemoteConfigData(
      state,
      LIVESTREAM_TOP_GIFTS_POLLING_SECONDS
    ),
    topGiftData: getLiveStreamData(state, [
      streamId,
      'session',
      sessionId,
      'topGift',
    ]),
  };
};

const mapStateToDispatch = dispatch => {
  return {
    fetchLivestreamTopGifts: payload =>
      dispatch(fetchLivestreamTopGifts(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(PaidInteractionPanel);
